import {connect} from 'react-redux'
import loadFeaturedPartTypeList from '@@client/parts/part-type/loadFeaturedPartTypeList'
import {buildSearchUrl} from '@@client/parts/parts-helper'
import Layout from '@@client/app/Layout'
import Col100 from '@@client/components/Col100'
import Loading from '@@client/components/Loading'
import {PhotoGrid, PhotoGridItem} from '@@client/parts/PhotoGrid'
import {getFallbackUrlByPartType} from '@@client/media/api'
import {getServerConfig} from '@@client/config'
import {getPartCategoriesPageContent} from '@@client/content/api'
import Markdown from '@@client/components/Markdown'

const OnePartType = ({partTypeInfo}) => {
    const photoUrl = getFallbackUrlByPartType(partTypeInfo.partTypeNumber)

    if(!photoUrl) return null

    const searchUrl = buildSearchUrl({partTypeSlug: partTypeInfo.defaultSlug})

    return (
        <PhotoGridItem href={searchUrl} src={photoUrl} width='400' height='296' alt={partTypeInfo.defaultName} label={partTypeInfo.defaultName} />
    )
}

const PartTypeList = ({partTypeStore}) => {
    if(partTypeStore.featuredList.doing) return <Loading />

    return (
        <>
            {partTypeStore.featuredList.entities.map(x => (<OnePartType key={x.id} partTypeInfo={x} />))}
        </>
    )
}

const mapStateToProps = ({parts: {partType}}) => ({
    partTypeStore: partType,
})

const mapDispatchToProps = (dispatch) => ({})

const Page = ({partTypeStore, title, lead, failed}) => {
    if(failed) return null

    loadFeaturedPartTypeList()

    return (
        <Layout title={title}>
            <Col100>
                <div className='container'>
                    <PhotoGrid>
                        <div className='content'>
                            <h1>{title}</h1>
                            <Markdown>{lead || ''}</Markdown>
                        </div>

                        <PartTypeList partTypeStore={partTypeStore} />
                    </PhotoGrid>
                </div>
            </Col100>
            <style jsx>
                {`
                    @import '@css/variables.css';

                    .container {
                        margin: 0 0 $padding--section--tb 0;

                        @media(--md) { margin: $padding--section--tb 0; }
                    }

                    .content {
                        grid-column: auto / span 3;
                        background: $c--gray--bg;
                        padding: 40px;

                        @media(--xxs) {
                            grid-column: auto / span 2;
                        }

                        @media(--md) {
                            grid-column: auto / span 2;
                            padding: 20px;
                        }
                    }
                `}
            </style>
        </Layout>
    )
}

const ExportPage = connect(mapStateToProps, mapDispatchToProps)(Page)

export default ExportPage

export async function getServerSideProps() {
    const config = getServerConfig()

    const result = await getPartCategoriesPageContent(config.content.apiUrl)

    return {
        props: result.success ? result.entity : {failed: true},
    }
}
